import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormBuilder, UntypedFormGroup } from '@angular/forms';

import { AddressPart, Dictionary } from 'app/shared/models';
import { Address } from 'app/modules/contacts/contacts.types';

@Component({
  selector: 'app-custom-address-string',
  templateUrl: './custom-address-string.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomAddressStringComponent implements OnInit, OnChanges {
  public addressForm: UntypedFormGroup;

  @Input() setValues: Dictionary<any>;
  @Input() readonly: boolean;

  @Output() onValueChanged = new EventEmitter<{ address: Address }>();

  constructor(private fb: FormBuilder) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.setValues?.currentValue?.address) {
      this.addressForm.setValue(changes.setValues.currentValue.address);
    }
  }

  ngOnInit(): void {
    this.buildForm();
  }

  private buildForm(): void {
    this.addressForm = this.fb.group({
      address_string: '',
      street: '',
      city: '',
      state: '',
      postal_code: '',
      latitude: '',
      longitude: '',
    });
  }

  public setAddress(addressString: string): void {
    this.addressForm.get('address_string').setValue(addressString);
    this.onValueChanged.emit({ address: this.addressForm.getRawValue() });
  }

  public onSelectAddressParts({
    locality,
    administrative_area_level_1,
    street_number,
    route,
    postal_code,
    lat,
    lng,
  }: AddressPart): void {
    this.addressForm.get('city').setValue(locality);
    this.addressForm.get('state').setValue(administrative_area_level_1);
    this.addressForm.get('postal_code').setValue(postal_code);
    this.addressForm.get('latitude').setValue(lat);
    this.addressForm.get('longitude').setValue(lng);

    if (route) this.addressForm.get('street').setValue(street_number ? `${street_number} ${route}` : route);
    else this.addressForm.get('street').setValue('');
  }
}
